document.documentElement.classList.add('js');
document.documentElement.classList.remove('no-js');

(function () {
  var config = null;

  function readConfig() {
    var el = document.getElementById('DogClubConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function inEditor() {
    return window.Shopify && window.Shopify.designMode;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function focusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a, button, input, select, textarea, [tabindex]')).filter(function (el) {
      return !el.disabled && el.getAttribute('tabindex') !== '-1' && !el.closest('[hidden]');
    });
  }

  function trap(event) {
    if (event.key !== 'Tab') return;
    var dialog = document.querySelector('.upsell:not([hidden]), #CartDrawer:not([hidden])');
    if (!dialog) return;
    var items = focusable(dialog);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
    var label = 'Cart, ' + count + (count === 1 ? ' item' : ' items');
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', label);
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      if (config) window.location.href = config.cartUrl;
      return;
    }
    drawer.hidden = false;
    document.body.classList.add('drawer-open');
    var title = document.getElementById('CartDrawerTitle');
    if (title) {
      title.setAttribute('tabindex', '-1');
      title.focus();
    }
  }

  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('drawer-open');
    var link = document.querySelector('[data-cart-link]');
    if (link) link.focus();
  }

  function openUpsell() {
    var dialog = document.getElementById('MembershipUpsell');
    if (!dialog) {
      goToCart();
      return;
    }
    dialog.hidden = false;
    document.body.classList.add('upsell-open');
    var title = document.getElementById('UpsellTitle');
    if (title) title.focus();
  }

  function closeUpsell() {
    var dialog = document.getElementById('MembershipUpsell');
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('upsell-open');
  }

  function goToCart() {
    if (inEditor()) {
      openDrawer();
      return;
    }
    window.location.href = config.cartUrl;
  }

  function cartErrorMessage(data) {
    if (!data) return 'Could not add that to the cart. Please try again.';
    return data.description || data.message || 'Could not add that to the cart. Please try again.';
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var error = new Error(cartErrorMessage(data));
          error.payload = data;
          throw error;
        }
        return data;
      });
    });
  }

  function itemIsMembership(item) {
    if (!config) return false;
    var type = (item.product_type || '').toLowerCase();
    if (type === 'membership') return true;
    return config.tiers.some(function (tier) {
      return tier.productId && tier.productId === item.product_id;
    });
  }

  function refreshCart() {
    return fetch(config.cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var has = cart.items.some(itemIsMembership);
        config.cartHasMembership = has;
        setCount(cart.item_count);
        return cart;
      });
  }

  function syncAttribute(has, cart) {
    var marker = 'Dog Club+ membership in cart.';
    var note = (cart && cart.note) || '';
    var lines = note.split('\n').filter(function (line) { return line.trim() !== marker; });
    if (has) lines.push(marker);
    return postJson(config.cartUpdateUrl, {
      attributes: { dogclub_free_shipping: has ? 'yes' : '' },
      note: lines.join('\n').trim()
    });
  }

  function refreshDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.getAttribute('data-section-id');
    var root = config.rootUrl || '/';
    if (root.slice(-1) !== '/') root += '/';
    var wasOpen = !drawer.hidden;
    return fetch(root + '?section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('shopify-section-' + sectionId);
        var current = document.getElementById('shopify-section-' + sectionId);
        if (next && current) current.replaceWith(next);
        if (wasOpen) {
          var again = document.getElementById('CartDrawer');
          if (again) {
            again.hidden = false;
            document.body.classList.add('drawer-open');
          }
        }
      })
      .catch(function () {});
  }

  function busy(button, label) {
    if (!button) return function () {};
    var previous = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) button.textContent = label;
    return function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = previous;
    };
  }

  function showError(target, message) {
    if (!target) return;
    target.hidden = false;
    target.textContent = message;
  }

  function tierById(id) {
    return config.tiers.find(function (tier) { return tier.id === id; });
  }

  function shouldUpsell(productId) {
    if (!config || config.customerIsMember || config.cartHasMembership) return false;
    return !config.tiers.some(function (tier) { return tier.productId === productId; });
  }

  function addMembership(tierId, button) {
    var tier = tierById(tierId);
    var errorBox = document.querySelector('[data-upsell-error]');
    if (!tier || !tier.variantId) {
      showError(errorBox, 'This membership is not connected to a product yet.');
      if (!errorBox) window.location.href = config.membershipUrl;
      return Promise.resolve();
    }
    var restore = busy(button, 'Adding you to the club…');
    var item = {
      id: tier.variantId,
      quantity: 1,
      properties: { 'Dogs fed each month': String(tier.dogs) }
    };
    if (tier.sellingPlanId) item.selling_plan = tier.sellingPlanId;
    return postJson(config.cartAddUrl, { items: [item] })
      .then(function () { return refreshCart(); })
      .then(function (cart) { return syncAttribute(true, cart); })
      .then(function () {
        closeUpsell();
        goToCart();
      })
      .catch(function (error) {
        restore();
        showError(errorBox, error.message);
      });
  }

  function addItem(item, productId, isMembership, button) {
    var restore = busy(button, isMembership ? 'Adding you to the club…' : 'Adding…');
    return postJson(config.cartAddUrl, { items: [item] })
      .then(function () { return refreshCart(); })
      .then(function (cart) {
        if (isMembership || itemIsMembership({ product_id: productId, product_type: isMembership ? 'Membership' : '' })) {
          return syncAttribute(true, cart).then(function () {
            closeUpsell();
            goToCart();
          });
        }
        return refreshDrawer().then(function () {
          if (shouldUpsell(productId)) openUpsell();
          else openDrawer();
        });
      })
      .catch(function (error) {
        restore();
        var slot = button && button.closest('form, [data-product-form-root]');
        var box = slot && slot.querySelector('[data-form-error]');
        showError(box, error.message);
      });
  }

  function initNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileNav');
    if (!toggle || !menu) return;
    function setOpen(open) {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open) {
        var closeBtn = menu.querySelector('[data-menu-close]');
        if (closeBtn) closeBtn.focus();
      }
    }
    toggle.addEventListener('click', function () {
      setOpen(menu.hidden);
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a, [data-menu-close]')) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function initCompactHeader() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group || !group.querySelector('.announce')) return;
    var ticking = false;
    function update() {
      group.classList.toggle('is-compact', window.scrollY > 28);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initFilters() {
    var panel = document.querySelector('.filter-panel');
    if (!panel) return;
    var narrow = window.matchMedia('(max-width: 989px)');
    function sync() {
      if (!narrow.matches) panel.open = true;
      else if (!panel.hasAttribute('data-filters-active')) panel.open = false;
    }
    sync();
    if (narrow.addEventListener) narrow.addEventListener('change', sync);
  }

  function initGallery() {
    document.querySelectorAll('[data-media-scroller]').forEach(function (scroller) {
      var gallery = scroller.parentElement;
      if (!gallery) return;
      var dots = gallery.querySelectorAll('[data-media-dot]');
      if (!dots.length) return;
      function paint() {
        var width = scroller.clientWidth || 1;
        var index = Math.round(scroller.scrollLeft / width);
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      scroller.addEventListener('scroll', function () {
        requestAnimationFrame(paint);
      }, { passive: true });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = Number(dot.getAttribute('data-media-dot'));
          var slide = scroller.children[index];
          if (!slide) return;
          scroller.scrollTo({
            left: slide.offsetLeft,
            behavior: reducedMotion() ? 'auto' : 'smooth'
          });
        });
      });
      paint();
    });
  }

  function initStickyBars() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-sticky-bar][data-sticky-for]').forEach(function (bar) {
      var anchor = document.getElementById(bar.getAttribute('data-sticky-for'));
      if (!anchor) return;
      var observer = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.2 });
      observer.observe(anchor);
    });
    var join = document.querySelector('.sticky-join');
    var tiers = document.getElementById('tiers');
    if (!join || !tiers) return;
    var tiersObserver = new IntersectionObserver(function (entries) {
      join.classList.toggle('is-hidden', entries[0].isIntersecting && entries[0].intersectionRatio >= 0.4);
    }, { threshold: [0.4] });
    tiersObserver.observe(tiers);
  }

  function initCart() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-cart-link]');
      if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-drawer-close]')) {
        closeDrawer();
        return;
      }
      var change = event.target.closest('[data-line-change]');
      if (change) {
        var key = change.getAttribute('data-key');
        var qty = Number(change.getAttribute('data-qty'));
        change.disabled = true;
        postJson(config.cartChangeUrl, { id: key, quantity: qty })
          .then(function () { return refreshCart(); })
          .then(function (cart) { return syncAttribute(cart.items.some(itemIsMembership), cart); })
          .then(refreshDrawer)
          .catch(function () { change.disabled = false; });
      }
    });
  }

  function initUpsell() {
    document.addEventListener('click', function (event) {
      var accept = event.target.closest('[data-upsell-accept]');
      if (!accept) return;
      var selected = document.querySelector('input[name="upsell_tier"]:checked');
      addMembership(selected ? selected.value : 'tier_2', accept);
    });
  }

  function initForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var join = event.submitter && event.submitter.dataset.joinTier;
      if (join) {
        event.preventDefault();
        addMembership(join, event.submitter);
        return;
      }
      var root = form.closest('[data-product-form-root]');
      if (!root) return;
      event.preventDefault();
      var data = new FormData(form);
      var productId = Number(root.getAttribute('data-product-id'));
      var isMembership = root.getAttribute('data-membership') === 'true';
      var item = {
        id: Number(data.get('id')),
        quantity: Number(data.get('quantity') || 1)
      };
      if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
      if (isMembership) {
        var tier = config.tiers.find(function (entry) { return entry.productId === productId; });
        if (tier) item.properties = { 'Dogs fed each month': String(tier.dogs) };
      }
      var button = event.submitter || form.querySelector('[type="submit"]');
      addItem(item, productId, isMembership, button);
    });

    document.addEventListener('click', function (event) {
      var quick = event.target.closest('[data-quick-add]');
      if (!quick) return;
      addItem({
        id: Number(quick.getAttribute('data-variant-id')),
        quantity: 1
      }, Number(quick.getAttribute('data-product-id')), false, quick);
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (error) { return; }
      var select = root.querySelector('[data-variant-select]');
      function selectedOptions() {
        return product.options.map(function (_, index) {
          var checked = root.querySelector('input[data-option-index="' + index + '"]:checked');
          return checked ? checked.value : null;
        });
      }
      function findVariant(options) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (option, index) { return option === options[index]; });
        });
      }
      function render(variant) {
        if (!variant || !select) return;
        select.value = String(variant.id);
        root.querySelectorAll('[data-product-price]').forEach(function (price) {
          price.textContent = variant.priceLabel;
        });
        root.querySelectorAll('[data-add-button]').forEach(function (button) {
          var label = variant.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold');
          button.textContent = label;
          button.disabled = !variant.available;
        });
        root.querySelectorAll('[data-option-index]').forEach(function (input) {
          var index = Number(input.getAttribute('data-option-index'));
          var trial = selectedOptions().slice();
          trial[index] = input.value;
          var match = findVariant(trial);
          var pill = input.closest('.option-pill');
          if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
        });
        if (variant.featuredMediaId) {
          var media = root.querySelector('[data-media-id="' + variant.featuredMediaId + '"]');
          if (media) media.scrollIntoView({ block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      root.addEventListener('change', function (event) {
        if (!event.target.matches('[data-option-index], [data-variant-select]')) return;
        if (event.target.matches('[data-variant-select]')) {
          var picked = product.variants.find(function (variant) { return String(variant.id) === event.target.value; });
          if (!picked) return;
          picked.options.forEach(function (option, index) {
            var input = root.querySelector('input[data-option-index="' + index + '"][value="' + CSS.escape(option) + '"]');
            if (input) input.checked = true;
          });
          render(picked);
          return;
        }
        render(findVariant(selectedOptions()));
      });
    });
  }

  function initDialogs() {
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-dialog-open]');
      if (open) {
        var dialog = document.getElementById(open.getAttribute('data-dialog-open'));
        if (dialog && dialog.showModal) dialog.showModal();
      }
      if (event.target.closest('[data-dialog-close]')) {
        var parent = event.target.closest('dialog');
        if (parent) parent.close();
      }
    });
  }

  function initCounters() {
    var nodes = document.querySelectorAll('[data-count-to]');
    if (!nodes.length) return;
    var reduce = reducedMotion();
    nodes.forEach(function (node) {
      var target = Number(node.getAttribute('data-count-to') || '0');
      if (reduce || target === 0) {
        node.textContent = target.toLocaleString();
        return;
      }
      node.textContent = '0';
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          var start = performance.now();
          function frame(now) {
            var progress = Math.min(1, (now - start) / 900);
            var eased = 1 - Math.pow(1 - progress, 3);
            node.textContent = Math.round(target * eased).toLocaleString();
            if (progress < 1) requestAnimationFrame(frame);
          }
          requestAnimationFrame(frame);
        });
      }, { threshold: 0.5 });
      observer.observe(node);
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function fillProvinces(countrySelect) {
    var wrap = countrySelect.closest('[data-address-fields]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-province-text]');
    var select = wrap.querySelector('[data-province-select]');
    var option = countrySelect.options[countrySelect.selectedIndex];
    var provinces = [];
    if (option && option.dataset.provinces) {
      try { provinces = JSON.parse(option.dataset.provinces); } catch (error) { provinces = []; }
    }
    if (!select || !text) return;
    if (provinces.length) {
      select.innerHTML = provinces.map(function (province) {
        return '<option value="' + escapeHtml(province[0]) + '">' + escapeHtml(province[1]) + '</option>';
      }).join('');
      if (select.dataset.default) select.value = select.dataset.default;
      select.hidden = false;
      select.name = 'address[province]';
      text.hidden = true;
      text.removeAttribute('name');
    } else {
      select.hidden = true;
      select.removeAttribute('name');
      text.hidden = false;
      text.name = 'address[province]';
    }
  }

  function initAddresses() {
    document.querySelectorAll('[data-country-select]').forEach(function (select) {
      var preferred = select.getAttribute('data-default');
      if (preferred) {
        Array.prototype.forEach.call(select.options, function (option) {
          if (option.value === preferred || option.text === preferred) option.selected = true;
        });
      }
      fillProvinces(select);
      select.addEventListener('change', function () { fillProvinces(select); });
    });
    document.querySelectorAll('[data-address-panel] .errors').forEach(function (error) {
      var panel = error.closest('[data-address-panel]');
      if (!panel) return;
      panel.hidden = false;
      if (panel.tagName === 'DETAILS') panel.open = true;
    });
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-address-toggle]');
      if (!toggle) return;
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
    });
  }

  function initRecommendations() {
    if (customElements.get('product-recommendations')) return;
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url || this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        var self = this;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('product-recommendations');
            if (next && next.innerHTML.trim()) self.innerHTML = next.innerHTML;
          })
          .catch(function () {});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    config = readConfig();
    window.DogClub = config;
    initNav();
    initCompactHeader();
    initFilters();
    initGallery();
    initStickyBars();
    initDialogs();
    initCounters();
    initAddresses();
    initRecommendations();
    initVariants();
    if (!config) return;
    initCart();
    initUpsell();
    initForms();
    refreshCart().then(function (cart) {
      var has = cart.items.some(itemIsMembership);
      var marker = 'Dog Club+ membership in cart.';
      var note = cart.note || '';
      var current = (cart.attributes && cart.attributes.dogclub_free_shipping) || '';
      var desired = has ? 'yes' : '';
      if (current !== desired || has !== (note.indexOf(marker) !== -1)) {
        return syncAttribute(has, cart);
      }
    }).catch(function () {});
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var upsell = document.getElementById('MembershipUpsell');
      if (upsell && !upsell.hidden) {
        if (inEditor()) closeUpsell();
        else if (config) window.location.href = config.cartUrl;
        return;
      }
      closeDrawer();
    }
    trap(event);
  });
})();
